// import { CAppusers } from './system-interface';
export class CAps {
  wrtdocketnumber: string;
  apsEvictType: string;
  apsCtrlNumber: string;
  apsEarliestevictdate: string;
  apsReferralDate: string;
  apsMarshalContactName: string;
  apsMarshalContactPhone: string;
  apstenantofrecord: string;
  apsfirstname: string;
  apslastname: string;
  apsaddress: string;
  apsany65yearold: string;
  apsApproxAge: string;
  apsmentalphysicalyesno: string;
  apsdescribeimpair: string;
  apswhyunabledefcourt: string;
  apswhynotbeable: string;
  apsDescribeOtherRisk: string;
  apsReferralSource: string;
  apslandlordname: string;
  apslandlordphone: string;
  apslandlordattny: string;
  apslandlordattnyphone: string;
  apslandlordsuperintendent: string;
  apslandlordsuperphone: string;
  apsAddendumattached: string;

  InsertbyUser: string;
  Insertdate: string;
  ModifyUser: string;
  ModifyDate: string;
  apsrowid: string;
  wrtrowid: string;
  apsComments: string;
  ApsRandomCrtl: string;

  rowidapsnolonger: string;
  wrtRowId: string;
  wrtDocketNumber: string;
  wrtApsNLongerTenant: string;
  apsnolongerdate: string;
  apsnolongernote: string;
  insertdate: string;
}
export class CWarrantStatusHistory {
  rowidwrtstatus: string;
  wrtDocketNumber: string;
  histStatus: string;
  histStatusDate: string;
  histStatusNotes: string;
  histuser: string;
  historigdate: string;
  insertdate: string;
}

export class CDataRequest {
  url: string;
  action: string;
  keySearch: string;
}
export class CCompany {
  action: string;
  companyID: number;
  companyName: string;
  website: string;
  email: string;
  mainNumber: string;
  faxNumber: string;
  isActive: number;
}

export class CIsActive {
  companyID: string;
  isActive: string;
  updateStatus: string;
}

export class CMarshal {
  marshalID: number;
  companyID: number;
  mainContact: string;
  officeName: string;
  street: string;
  apartmentNumber: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  email: string;
  mainNumber: string;
  faxNumber: string;
  isActive: number;
  username: string;
  password: string;
  dbConnectionString: string;
}

export class CLawyer {
  lawyerID: number;
  companyID: number;
  name: string;
  street: string;
  apartmentNumber: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  email: string;
  mainNumber: string;
  faxNumber: string;
  isActive: number;
  username: string;
  password: string;
}

export class CLawyerList {
  key: number;
  station: string;
}

export class CDocket {
  wrtPremisesCounty: string;
  wrtIndexnumber: string;
  wrtindexyear: string;
  wrtDocketNumber: string;
  WrtType: string;
  wrtstatus: string;

  wrtBankruptcy: string;
  wrtAnimalControl: string;
  wrtForeClosure: string;
  wrtapsnolonger: string;
  wrtdate: string;
  wrtCloseDate: string;
  eievictiondate: string;
  wrtAttnyCompanyName: string;
  wrtAttnyFirstName: string;
  wrtAttnyMiddleName: string;
  wrtAttnyLastName: string;
  wrtAttnyAddress: string;
  wrtAttnyCity: string;
  wrtAttnyState: string;
  wrtAttnyZipCode: string;
  wrtAttnyPhone1: string;
  wrtAttnyPhone2: string;
  wrtAttnyFax1: string;
  wrtAttnyFax2: string;

  wrtLandLordCompanyName: string;
  wrtLandLordFirstName: string;
  wrtLandLordMiddleName: string;
  wrtLandLordLastName: string;
  wrtLandlordFullName: string;
  wrtLandLordAddress: string;
  wrtLandLordCity: string;
  wrtLandLordState: string;
  wrtLandLordZipCode: string;
  wrtLandLordContactName: string;
  wrtLandLordPhone1: string;
  wrtLandLordPhone2: string;
  wrtlandlordFax1: string;
  wrtlandlordfax2: string;

  wrttenantfirstname: string;
  wrttenantmiddlename: string;
  wrttenantlastname: string;
  WrtTenantQty: string;

  wrtPremisesAddress: string;
  wrtPremisesCity: string;
  wrtPremisesState: string;
  wrtPremisesZipCode: string;

  wrtPremisesRoom: string;
  wrtPremisesFloor: string;
  wrtPremisesAptNumber: string;
  wrtrowid: string;

  wrtStatusSignReject: string;
  wrtStatusIssuedComment: string;
  wrtSignedDate: string;
  wrtStatusComments: string;

  wrtVacatedSatus: boolean;
}

export class CAppusers {
  FirstName: string;
  LastName: string;
  phoneNumber: string;
  email: string;
  userName: string;
  password: string;
  name: string;
  avatar: string;
  userType: string;
}

export class CCredential {
  userName: string;
  password: string;
  usertype: string;
}

export class CUnderTenant {
  UnderTenantFullName: string;
}

export class CNoticeOfEvition {
  wrtrowid: string;
  datecopymailed: string;
  dateserved: string;
  typeofservice: string;
  GrantedOrPrinted: string;
  LastAttempt: string;
  LastServicePerformed: string;
  OnWhom: string;
  ProcessServer: string;
  servedlicense: string;
  Personal: string;
  Substitution: string;
  Conspicuous: string;
  NOEServerBy: string;
  ASSOCIATEPROSERVERBYLICENSE: string;
  NOEWasServer: string;
  Comments: string;
}

export class CCustomSeachFields {
  county: string;
  number: string;
  year: string;
  docket: string;
  crossRef: string;
  tenantFirstName: string;
  tenantLastName: string;
  landLordName: string;
  premisesAddress: string;
  marshalID: string;
  wrtAttnyRowid: Number;
}

export class CCounty {
  name: string;
}

export class CMarshalLink {
  MarshalID: string;
  LawyerID: string;
}
